import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import { FormikProps, getIn } from 'formik';

interface CustomTextFieldProps extends Omit<TextFieldProps, 'name'> {
  name: string;
  formik: FormikProps<any>;
}

export default function TextField({ formik, name, ...props }: CustomTextFieldProps) {
  const error = getIn(formik.touched, name) && Boolean(getIn(formik.errors, name));
  const helperText = getIn(formik.touched, name) && getIn(formik.errors, name);

  return (
    <MuiTextField
      fullWidth
      size="small"
      margin="normal"
      {...props}
      name={name}
      value={getIn(formik.values, name)}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={error}
      helperText={helperText as string}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '10px',
          '&:hover fieldset': {
            borderColor: '#667eea',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#667eea',
          },
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: '#667eea',
        },
        mt: 0,
        mb: 0,
        ...props.sx,
      }}
    />
  );
}
